import { mapProps } from 'recompose';
import { ObjectShim } from '@packages/helpers/core/shims/object-shim';
import { FunctionShim } from '@packages/helpers/core/shims/function-shim';

export const pickProps = (constraints = [], mapper) =>
  mapProps(props => ({
    ...ObjectShim.pick(props, constraints),
    ...(FunctionShim.isFunction(mapper) && mapper(props))
  }));
